import { render, staticRenderFns } from "./ThreadCompactItem.vue?vue&type=template&id=5e430560&scoped=true&"
import script from "./ThreadCompactItem.vue?vue&type=script&lang=js&"
export * from "./ThreadCompactItem.vue?vue&type=script&lang=js&"
import style0 from "./ThreadCompactItem.vue?vue&type=style&index=0&id=5e430560&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e430560",
  null
  
)

export default component.exports